export default class SearchHold {

    holdTicketId: string;
    optionNumber: string;
    cparNumber: string;
    materialNumber: string;
    materialDesc: string;
    returnAuthNum: string;
    purchaseOrderNum: string;
    salesOrderNumber: string;

    closedStartDate: string | Date;
    closedEndDate: string | Date;
    createdStartDate: string | Date;
    createdEndDate: string | Date;
    daysOpen: number;

    dispositions: string[];
    defects: string[];
    verifications: string[];
    plants: string[];
    statuses: number[];
    limitResults: boolean;

    constructor(){
        this.holdTicketId = "";
        this.optionNumber = "";
        this.cparNumber = "";
        this.materialNumber = "";
        this.materialDesc = "";
        this.returnAuthNum = "";
        this.purchaseOrderNum = "";
        this.salesOrderNumber = "";

        this.closedStartDate = "";
        this.closedEndDate = "";
        this.createdStartDate = "";
        this.createdEndDate = "";
        this.daysOpen = 0;

        this.dispositions = [];
        this.defects = [];
        this.verifications = [];
        this.plants = [];
        this.statuses = [9];
        this.limitResults = true;
    }

}


